module.exports = __webpack_public_path__ + "static/media/IMG_8763.d7bc6089.JPG";